module.exports = __webpack_public_path__ + "img/06 Animation 2-squashed.fa09be5e.jpg";